import { Color, DefaultValue, getDefaultTransition, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const HitsWrapper = styled.div`
  width: 100%;
  max-width: calc(100% - ${Spacing.S32} * 2);
  max-height: 350px;
  margin-top: ${Spacing.S6};
  padding: ${Spacing.S8};
  border-radius: ${Spacing.S4};
  position: absolute;
  z-index: 1;
  background-color: ${Color.White};
  box-shadow: 0 10px 70px ${transparentize(0.65, Color.Grey950)};
  overflow: scroll;
  overflow-x: hidden;
`

export const NoResultsWrapper = styled.li`
  display: flex;
  justify-content: center;
  padding: ${Spacing.S8} 0;
`

export const HitsList = styled.ul``

interface HitListItemProps {
  isFocused?: boolean
}

export const HitListItem = styled.li<HitListItemProps>`
  border-radius: ${DefaultValue.BorderRadius};
  overflow: hidden;
  ${getDefaultTransition('background-color')};

  &:hover {
    background-color: ${transparentize(0.75, Color.Grey300)};
  }

  ${({ isFocused }) =>
    isFocused &&
    css`
      background-color: ${transparentize(0.75, Color.Grey300)};
    `}
`
